import { useLazyWorkplaceMemberRoleQuery } from '../../../graphql/graphql';
import { useEffectAsync } from '../../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import {
	selectUser,
	setUserIsDoctor,
	setUserIsManager,
	setUserIsNurse,
	setUserRolesLoaded,
	setUserRolesLoading,
} from '../../../store/reducers/userSlice';
import { useAppContext } from '../../../Services/AppContext';

interface UseWorkplaceRoleProps {
	userId: string;
	workplaceId: string;
}

const useWorkplaceRole = ({ userId, workplaceId }: UseWorkplaceRoleProps) => {
	const [getRoles] = useLazyWorkplaceMemberRoleQuery();
	const { isNurse, isDoctor, isManager, rolesLoading, rolesLoaded } =
		useSelector(selectUser);
	const { userData } = useAppContext();
	const dispatch = useDispatch();

	useEffectAsync(async () => {
		if (rolesLoading || rolesLoaded) {
			return;
		}

		dispatch(setUserRolesLoading(true));

		const { workplaceMember } = await getRoles({
			userId: userId ?? userData?.id,
			workplaceId,
		}).unwrap();

		for (const memberRole of workplaceMember?.workplaceMemberRoles || []) {
			if (memberRole?.role?.key === 'doctor') {
				dispatch(setUserIsDoctor(true));
			} else if (memberRole?.role?.key === 'nurse') {
				dispatch(setUserIsNurse(true));
			} else if (memberRole?.role?.key === 'manager') {
				dispatch(setUserIsManager(true));
			}
		}

		dispatch(setUserRolesLoading(false));
		dispatch(setUserRolesLoaded(true));
	});

	return {
		isNurse,
		isDoctor,
		isManager,
		isDone: rolesLoaded,
	};
};

export default useWorkplaceRole;
